import React, { Component } from 'react';
import moment from 'moment';

import CamdetectParkinglocationSettingsForm from './CamdetectParkinglocationSettingsForm'
import CamdetectParkinglocationsModel from './CamdetectParkinglocationsModel'
import { defaultSorter, dateSorter } from './Helpers';
import UserModel from './UserModel';

import { Table, Popconfirm, Typography, Divider, message } from 'antd';

class CamdetectParkinglocationsTable extends Component {

  state = {
    children: [],
    camdetectParkinglocationSettingsFormData: null
  }

  render() {
    const columns = [{
      title: 'Lokalita',
      dataIndex: 'parkingLocationName',
      key: 'parkingLocationName',
      width: 350,
      sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName),
      defaultSortOrder: 'ascend',
    }, {
      title: 'Kapacita',
      dataIndex: 'totalCapacity',
      key: 'totalCapacity',
    }, {
      title: 'Obsazeno',
      dataIndex: 'totalOcc',
      key: 'totalOcc'
    }, {
      title: 'Zpoždění před odesláním (s)',
      dataIndex: 'delayPublishOcc',
      key: 'delayPublishOcc'
    }, {
      title: 'Název posluchače',
      dataIndex: 'listenerName',
      key: 'listenerName',
    }, {
      title: 'Akce',
      key: 'Action',
      width: 200,
      render: (text, record) => {
        if (UserModel.isInRoles(['ADMIN', 'CAMDETECT_PARKINGLOCATIONS_WRITE'])) {
          return (
            <div>
              <a onClick={(e) => {
                this.setState({
                  camdetectParkinglocationSettingsFormData: record
                });
              }}>Nastavení</a>
              <Divider type="vertical" />
              <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                this.props.onRemoveRow(record.id)
              }} okText="Ano" cancelText="Ne">
                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
              </Popconfirm>
            </div>
          );
        }
      },
    }];


    return (
      <div>
        <Table
          size='small'
          rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
          loading={this.props.loading ? this.props.loading : false}
          columns={columns}
          dataSource={this.props.data}
          pagination={{
            showSizeChanger: true,
            defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
              ? parseInt(localStorage.getItem('table_pageSize'))
              : 10,
            onShowSizeChange: (current, size) => {
              localStorage.setItem('table_pageSize', size);
            }
          }}
          style={{ border: '0px' }} />
        <CamdetectParkinglocationSettingsForm
          type="modal"
          modalVisible={this.state.camdetectParkinglocationSettingsFormData === null ? false : true}
          initialValues={this.state.camdetectParkinglocationSettingsFormData}
          onModalCancel={(form) => {
            form.resetFields();
            this.setState({ camdetectParkinglocationSettingsFormData: null });
          }}
          onSuccess={(form, values) => {
            CamdetectParkinglocationsModel.patch(this.state.camdetectParkinglocationSettingsFormData.id, values)
              .then(() => {
                message.success("Změna byla uložena!");
                form.resetFields();
                this.setState({
                  camdetectParkinglocationSettingsFormData: null
                });
                if (this.props.onAnyFormSuccess) {
                  this.props.onAnyFormSuccess();
                }
              })
              .catch(err => {
                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
              })
          }} />
      </div>
    );
  }
}

export default CamdetectParkinglocationsTable;


// WEBPACK FOOTER //
// ./src/components/CamdetectParkinglocationsTable.js